<template>
  <div class="relative w-100">
    <div class="relative swiper-bg">
      <div class="relative mw8-25 center">
        <div class="swiper-button-prev pointer outline-0" slot="button-prev"></div>
        <img class="absolute swiper-bubble" src="/uploads/OL19_Bubbles-web.png" />
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide :style="{'height': height}" v-for="(item, index) in accolades_carousel.accolades" :key="'press-accolades-swiper-slide-' + index">
            <div class="db absolute abs-vert-center is-white w-100">
              <span class="is-lorano-bold f15px is-light-blue2">Accolades</span>
              <p class="is-tablet-narrow-semi-bold f3 f1-ns pv4 lh-title" v-html="item.text"></p>
              <span class="f25px is-tablet-cond-bold">-{{item.source}}</span>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next pointer outline-0" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      background:{},
      height:{},
    },
    data () {
      return {
        swiperOptions: {
          autoplay: {
            delay: 7000,
          },
          speed: 800,
          autoplayDisableOnInteraction: false,
          loop: true,
          initialSlide: 0,
          //pagination: '.swiper-pagination',
          paginationClickable: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          keyboardControl: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          initialSlide: 0,
          spaceBetween: 15,
          centeredSlides: true,
          freeMode: false,
          slidesPerView: 1,
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      },
      accolades_carousel: function () {
        var accoladesData = this.$store.getters.filterPagesByName('accolades-carousel.markdown');
        return accoladesData[0];
      }
    },
    methods: {
      swiperInit() {
          this.swiper.update();
      },
      addBG: function() {
        return 'background-image:url('+this.background+');background-size:cover;background-position:bottom';
      },
    },
    created() {
      window.addEventListener('load', this.swiperInit);
      window.addEventListener('resize', this.swiperInit);
    },
    destroyed() {
      window.removeEventListener('load', this.swiperInit);
      window.removeEventListener('resize', this.swiperInit);
    }
  }
    
</script>